// Barcode helpers for the dispatch pack screen.
//
// An item can carry several scannable barcodes (products.barcode plus
// sku_barcodes alternates — case packs, relabel runs, multipacks). The
// BE sends them as `barcodes[]`; older payloads and demo helpers only
// set the single legacy `barcode` field.

type BarcodeCarrier = { sku: string; barcode: string; barcodes?: string[] };

// Every barcode a scan should match for this line.
export const scannableBarcodes = (item: BarcodeCarrier): string[] =>
    item.barcodes && item.barcodes.length > 0
        ? item.barcodes
        : item.barcode
            ? [item.barcode]
            : [];

// What the item card displays: up to `max` barcodes plus how many more
// were hidden. Values identical to the SKU are dropped — the BE falls
// back to the SKU when a product has no barcode, and repeating the SKU
// line adds nothing.
export const displayBarcodes = (
    item: BarcodeCarrier,
    max = 2,
): { shown: string[]; hidden: number } => {
    const all = scannableBarcodes(item).filter(b => b && b !== item.sku);
    return { shown: all.slice(0, max), hidden: Math.max(0, all.length - max) };
};
